import React from "react";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

export default function LineSeparator() {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  // Define colors based on theme
  const gradient = theme === "dark"
    ? "from-[#00F0FF] via-transparent to-[#FF007F]"
    : "from-[#A5F3FC] via-[#DBD4FF]/0 to-[#F472B6]";

  const opacity = theme === "dark" ? "opacity-30" : "opacity-70";

  return (
    <></>
    //<div className={`my-6 h-px bg-gradient-to-r ${gradient} ${opacity}`} />
  );
}
